import type { Column2, Content, HeaderCell, HeaderRow } from '../../models';

import { cloneObject } from '../../utilities';
import { TableTypes, VisualsWithDataTypes } from '../../config/constants';
import { table1ToTable2, columnIdx, headerCellIdx, containerPadding } from '../charts23/table2';

export const validateContentVersion72 = (content: Content): boolean => {
  const { type, typeSpecific } = content;
  if (typeSpecific.version < 72) {
    if (VisualsWithDataTypes.includes(type) && typeSpecific.fields && typeSpecific.table) {
      typeSpecific.table2 = typeSpecific.table2 ?? table1ToTable2(typeSpecific.table, typeSpecific.fields);

      if (TableTypes.includes(type)) {
        if (typeSpecific?.style?.colors2 && !['gradient', 'range'].includes(typeSpecific.style.colors2.type)) typeSpecific.style.colors2.type = 'gradient';
      }

      // Index Column
      const idxColumn = typeSpecific.table2.columns.items.find((col: Column2) => col.fieldName === 'index');
      if (!idxColumn) typeSpecific.table2.columns.items.unshift(cloneObject(columnIdx));

      const defaultHeader = typeSpecific.table2.header.rows.find((headerRow: HeaderRow) => headerRow.id === 'default');
      if (defaultHeader) {
        const indexCell = defaultHeader.items.find((headerCell: HeaderCell) => headerCell.id === 'default-#');
        if (!indexCell) defaultHeader.items.unshift(cloneObject(headerCellIdx));
      }

      typeSpecific.table2.charts = typeSpecific.table2.charts ?? { items: [] };
      typeSpecific.table2.columns.sortable = typeSpecific.table2.columns.sortable ?? true;
      typeSpecific.table2.search.placeholder = typeSpecific.table2.search.placeholder ?? 'Search';
      typeSpecific.table2.style.containerPadding = typeSpecific.table2.style.containerPadding ?? containerPadding;

      typeSpecific.table2.pagination.icons = typeSpecific.table2.pagination.icons ?? {
        first: { value: 'icon:playback-first' },
        prev: { value: 'icon:playback-prev' },
        next: { value: 'icon:playback-next' },
        last: { value: 'icon:playback-last' },
      };
    }

    // typeSpecific.version = 72;
  }

  return true;
};
